import { QuotasSelected } from "./components/QuotasSelected";

export const StepTwo = () => <QuotasSelected />;

